export const SECTION_BUTTONS = [
  {
    name: "quantity",
    title: "Quantity",
    desc: "quantity",
    progress: 0
  },
  {
    name: "checkInformationSection",
    title: "Imprint",
    desc: "Please enter your imprint information:",
    progress: 1
  },
  { name: "checkDesignSection", title: "Design", progress: 2 },
  { name: "checkReviewSection", title: "Review", progress: 3 }
];
